import { confirm } from "@verbleif/lib/src/composables/Dialog/confirm";
import { useDialogStack } from "@verbleif/lib/src/composables/Dialog/useDialogStack";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import { useImpersonationStore } from "../features/Auth/Impersonate/useImpersonationStore";
import { clearPersistedQueryCache } from "./queryPersister";

export function useImpersonateFailedDialog() {
  const impersonationStore = useImpersonationStore();
  const stack = useDialogStack();
  const { t } = useI18n();

  function onClose() {
    impersonationStore.showImpersonateError.value = null;
    impersonationStore.reset();
    // The persisted cache would otherwise restore queries fetched under the other identity.
    clearPersistedQueryCache();
    window.location.reload();
  }

  watch(() => impersonationStore.showImpersonateError.value, (error) => {
    if (error) {
      if (stack.getById("impersonate-failed-dialog")) {
        return;
      }
      void confirm({
        id: "impersonate-failed-dialog",
        title: t("settings.users.impersonate_failed_title"),
        message: error,
        variant: "danger",
        icon: "circle-alert",
        confirmText: t("base.close"),
        hideCancel: true,
      }).finally(onClose);
      return;
    }
    const existing = stack.getById("impersonate-failed-dialog");
    if (existing) {
      void stack.popAfterSave(existing.instanceId);
    }
  }, { immediate: true });
}
